import { StockType } from 'types/stock'
import { useMemo } from 'react'
import differenceInMinutes from 'date-fns/differenceInMinutes'

// 引数のstocksの通知時刻がすべて30分より前であれば通知可能(true)
const useCanBeNotified = (stocks: StockType[]): boolean => {
  return useMemo(() => {
    const now = new Date()
    return stocks.every((stock) => {
      if (!stock.last_notified_time) return true
      const lastNotifiedAt = stock.last_notified_time.toDate()
      return differenceInMinutes(now, lastNotifiedAt) > 30
    })
  }, [stocks])
}

export default useCanBeNotified
